import React from "react";
import cn from "classnames";
import styles from "./Item.module.sass";
import Icon from "../../../../components/Icon";

const Item = ({ item, className }) => {
    return (
        <>
            <a 
                href={item.linkedin} 
                target="_blank" 
                rel="noopener noreferrer"
                className={cn(styles.item, className)}
            >
                <div className={styles.avatar}>
                    <img src={item.image} alt="Avatar" />
                </div>
                <div className={styles.nameContainer}>
                    {item.linkedin && (
                        <div className={styles.linkedinIcon}>
                            <Icon name="linkedin" />
                        </div>
                    )}
                    <div className={styles.man}>{item.name}</div>
                </div>
                <div className={styles.position}>{item.position}</div>
            </a>
        </>
    );
};

export default Item;